// src/components/NotificationPopup.js
import React from 'react';
import { getText } from '../i18n';

const NotificationPopup = ({ onConfirm, onClose }) => {
    return (
        <div style={styles.backdrop}>
            <dialog style={styles.dialog} open>
                <h4 style={styles.title}>{getText('msg_8ec6f7d400b2')}</h4>
                <p>{getText('msg_a0e648b681a4')}</p>
                <div style={styles.buttonContainer}>
                    <button onClick={onConfirm} style={{ ...styles.button, ...styles.positiveButton }}>
                        {getText('msg_da3967d004ec')}
                    </button>
                    <p onClick={onClose} style={{ ...styles.button, ...styles.negativeButton }}>
                        {getText('msg_98f55db57c8e')}
                    </p>
                </div>
            </dialog>
        </div>
    );
};

const styles = {
    backdrop: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // Black transparent background
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: '9998', // Ensure backdrop is below the dialog
    },
    dialog: {
        border: 'none',
        borderRadius: '8px',
        padding: '20px',
        width: 'calc(100% - 40px)', // 100% width minus 20px margin on each side
        maxWidth: '400px', // Optional: set a max width for better appearance
        textAlign: 'center',
        zIndex: '9999',
        margin: '0 auto',
        position: 'fixed', // Use fixed positioning
        top: '50%', // Center vertically
        left: '50%', // Center horizontally
        transform: 'translate(-50%, -50%)', // Adjust position to truly center
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)', // Add shadow effect
    },
    title: {
        marginBottom: '20px'
    },
    buttonContainer: {
        marginTop: '20px',
    },
    button: {
        margin: '0 10px',
        padding: '10px 15px',
        cursor: 'pointer',
        transition: 'background-color 0.3s',
    },
    positiveButton: {
        border: 'none',
        borderRadius: '5px',
        backgroundColor: '#007bff',
        color: 'white',
    },
    negativeButton: {
        color: '#007bff',
    },
};

export default NotificationPopup;
